// Preferencias locales del modal contextual de invitación (primera vez que el comercio
// elegible entra al menú). Persisten en localStorage para que el modal NO sea bloqueante
// ni recurrente: se muestra una sola vez por comercio + feature, salvo que el usuario
// elija explícitamente "Recordármelo más tarde" (en cuyo caso se vuelve a ofrecer en la
// próxima sesión, pero nunca dos veces en la misma).
//
// Keyed por commerce_id + feature_key igual que el cache de resolución: la preferencia de
// un comercio no contamina a otro en el mismo navegador (multi-sucursal). No se borra en
// login (resetStore no toca localStorage), así que la decisión sobrevive al re-login.

import { getActiveCommerceId } from './cache';

const PREFIX = 'plick:feature-invitation-seen:v1:';

function storageKey(commerceId: string, featureKey: string): string {
  return `${PREFIX}${commerceId}:${featureKey}`;
}

// ¿Ya marcamos esta invitación como "no volver a preguntar" para este comercio + feature?
export function isInvitationDismissed(featureKey: string, commerceId = getActiveCommerceId()): boolean {
  if (typeof window === 'undefined' || !commerceId) return false;
  try {
    return window.localStorage.getItem(storageKey(commerceId, featureKey)) === '1';
  } catch {
    return false;
  }
}

// Marca la invitación como vista permanentemente ("no volver a preguntar").
export function dismissInvitation(featureKey: string, commerceId = getActiveCommerceId()): void {
  if (typeof window === 'undefined' || !commerceId) return;
  try {
    window.localStorage.setItem(storageKey(commerceId, featureKey), '1');
  } catch {
    // ignore quota / private-mode
  }
}
